import { CalendarEntry, CalendarEntryId } from "@ollie-sports/models";
import { getUniversalHelpers } from "../../helpers";

export async function calendarEntry__client__getDoc(p: { calendarEntryId: CalendarEntryId }): Promise<CalendarEntry | null> {
  const { ollieFirestoreV2: h } = getUniversalHelpers();
  return await h.CalendarEntry.getDoc(p.calendarEntryId);
}

// i18n certified - complete
